(() => {
  const root = document.querySelector('[data-whatsapp-support]');
  if (!root || root.dataset.ready === 'true') return;

  root.dataset.ready = 'true';
  const launcher = root.querySelector('[data-support-open]');
  const dialog = root.querySelector('[data-support-dialog]');
  const backdrop = root.querySelector('[data-support-backdrop]');
  const closeButton = root.querySelector('[data-support-close]');
  const topicLinks = [...root.querySelectorAll('[data-support-topic]')];

  const focusable = () => [...dialog.querySelectorAll('a[href], button:not([disabled])')];

  function openDialog() {
    dialog.hidden = false;
    backdrop.hidden = false;
    launcher.setAttribute('aria-expanded', 'true');
    document.body.classList.add('cx-open');
    closeButton.focus();
  }

  function closeDialog({ restoreFocus = true } = {}) {
    dialog.hidden = true;
    backdrop.hidden = true;
    launcher.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('cx-open');
    if (restoreFocus) launcher.focus();
  }

  launcher.addEventListener('click', openDialog);
  closeButton.addEventListener('click', () => closeDialog());
  backdrop.addEventListener('click', () => closeDialog());
  topicLinks.forEach((link) => link.addEventListener('click', () => closeDialog({ restoreFocus: false })));

  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDialog();
      return;
    }

    if (event.key !== 'Tab') return;
    const elements = focusable();
    if (!elements.length) return;
    const first = elements[0];
    const last = elements[elements.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
